<app-loading [show]="loadingService.isShow" [value]="loadingService.progress" [mode]="loadingService.progress === 0 || loadingService.progress === 100 ? 'indeterminate' : 'determinate' "></app-loading>
<router-outlet></router-outlet>
<div [ngClass]="keyboardService.keyboardIsOpen() && keyboardService.keyboardIsActive() ? 'keyboard-show' : ''">
</div>
<app-keyboard #keyboard style="z-index: 10000; position: fixed"></app-keyboard>
<app-ai-help-widget></app-ai-help-widget>
